import React from "react";

const COURSE_VARIANTS = new Set([
  "python-tc",
  "java-tc",
  "python-online",
  "java-online",
]);

/**
 * Outer: padding + gradient background (rim). Inner: solid fill only.
 */
export default function ReachRim({
  variant,
  className = "",
  outerClassName = "",
  children,
}) {
  let outerClass = `reach-rim reach-rim--${variant}`;
  if (COURSE_VARIANTS.has(variant)) {
    outerClass += " reach-rim--course";
  }

  return (
    <div className={`${outerClass} ${outerClassName}`.trim()}>
      <div className={`reach-rim__inner ${className}`.trim()}>{children}</div>
    </div>
  );
}
